<template>
  <v-row>
    <v-col>
      <v-card class="elevation-0">
        <v-card-text>
          <div><span class="title">Roles</span><v-btn text class="ml-2 mt-n1" small color="grey">ADD</v-btn></div>
          <v-data-table
            :headers="headers"
            :items="roles"
            :items-per-page="10"
          >
            <template v-slot:header.assignments>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-icon v-on="on">mdi-account-multiple</v-icon>
                </template>
                <span>Users Assigned</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-text>
          <div><span class="title">Permissions</span><v-btn text class="ml-2 mt-n1" small color="grey">ADD</v-btn></div>
          <v-data-table
            :headers="headers"
            :items="permissions"
            :items-per-page="10"
          ></v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'AdminPermissionsIndex',

  data: () => ({
    loading: true,
    items: {},
    children: {},
    assignments: {},
    users: {},

    headers: [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
        width: '250px'
      },
      {
        text: 'Description',
        align: 'start',
        sortable: false,
        value: 'description',
      },
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'assignments',
        width: '80px'
      }
    ]
  }),
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    roles() {
      let roles = [];
      for(let i = 0; i < Object.keys(this.items).length; i++) {
        let key = Object.keys(this.items)[i];
        if(this.items[key].type == 1) roles.push(this.items[key]);
      }
      return roles;
    },
    permissions() {
      let perms = [];
      for(let i = 0; i < Object.keys(this.items).length; i++) {
        let key = Object.keys(this.items)[i];
        if(this.items[key].type == 2) perms.push(this.items[key]);
      }
      return perms;
    }
  },
  methods: {
    getDataFromApi() {
      this.loading = true;

      this.$http.get('permissions')
        .then(result => {
          this.items = result.data.items;
          this.children = result.data.children;
          this.assignments = result.data.assignments;
          this.users = result.data.users;
        })
        .catch(err => {
          console.log(err);
          this.$swal.fire('Error', 'There was an error loading permission data', 'error');
          this.$router.go(-1);
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
};
</script>
